module.exports = __webpack_public_path__ + "img/logo.ddb6061b.png";